import { useEffect, useState } from 'react';
import { Table, Button, Modal, Popconfirm } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import api from '../utils/apiClient';
import UserForm from './UserForm';

const TenantUsersTable = ({ tenantId, onChange }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingUser, setEditingUser] = useState(null);

    // Fetch users for existing tenant
    useEffect(() => {
        if (tenantId) {
            setLoading(true);
            api.get(`/tenants/${tenantId}/users`)
                .then(({ data }) => {
                    setData(data);
                    onChange?.(data);
                })
                .catch((e) => console.error(e))
                .finally(() => setLoading(false));
        }
    }, [tenantId, onChange]);

    const handleAddUser = (user) => {
        const updated = [...data, user];
        setData(updated);
        onChange?.(updated);
        setEditingUser(null);
    };

    const handleUpdateUser = (user) => {
        const updated = data.map((u) => (u.user_id === user.user_id ? user : u));
        setData(updated);
        onChange?.(updated);
        setEditingUser(null);
    };

    const handleRemove = async (userId) => {
        try {
            await api.delete(`/tenants/${tenantId}/users/${userId}`)
            const updated = data.filter((u) => u.user_id !== userId);
            setData(updated);
            onChange?.(updated);
        } catch (err) {
            // FIXME: Do we have a standard way to handle UI errors?
            console.error(err);
        }
    };

    const columns = [
        { title: 'Organization', dataIndex: 'organization' },
        { title: 'First Name', dataIndex: 'first_name' },
        { title: 'Last Name', dataIndex: 'last_name' },
        { title: 'Email', dataIndex: 'email' },
        { title: 'Phone', dataIndex: 'phone' },
        {
            title: 'Username',
            dataIndex: 'username',
            render: (_, record) => (
                <a onClick={() => setEditingUser(record)}>{record.username}</a>
            ),
        },
        {
            title: '',
            render: (_, record) => (
                <Popconfirm
                    title="Remove this user?"
                    onConfirm={() => handleRemove(record.user_id)}
                >
                    <Button danger icon={<DeleteOutlined />} />
                </Popconfirm>
            ),
        },
    ];

    return (
        <>
            { tenantId && (
                <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    onClick={() => setEditingUser({})}
                    style={{ marginBottom: 16 }}
                >
                    Add User
                </Button>)
            }

            <Table
                rowKey="user_id"
                loading={loading}
                dataSource={data}
                columns={columns}
            />

            <Modal
                open={!!editingUser}
                footer={null}
                onCancel={() => setEditingUser(null)}
                destroyOnClose
            >
                <UserForm
                    user={editingUser?.user_id ? editingUser : null}
                    tenantId={tenantId}
                    onSuccess={(u) =>
                        editingUser?.user_id ? handleUpdateUser(u) : handleAddUser(u)
                    }
                    onCancel={() => setEditingUser(null)}
                />
            </Modal>
        </>
    );
};

export default TenantUsersTable;